import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router";

import { Select, DatePicker } from "antd";
import moment from "moment";
import "./ExperienceFilter.css";

import openkit from "openkit";
import { AppContext } from "../../context";
import { getProductPriceForDate } from "../../library/products";
import { API_URL } from "../../config/config";
import { EXPERIENCES } from "../../entities/experience/experiencesConstants";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import { searchExperiences } from "./searchExperiences";

openkit.config.app_url = API_URL;

const getAllUniqueValues = (propertyName, objArray) => {
  if (!objArray.length || !propertyName) return;
  let allValues = [];
  for (const element of objArray) {
    if (element) allValues.push(element[propertyName]);
  }
  let uniqueValues = [...new Set(allValues)];
  return uniqueValues;
};

const StoreExperienceFilter = ({ products, setProducts, store }) => {
  const [categories, setCategories] = useState([]);
  const [durations, setDurations] = useState([]);
  const info = useContext(AppContext);

  const location = useLocation();

  const createSelectOptions = (categories) => {
    const categoriesSelectOptions = categories.map((c) => ({
      label: info.t(c),
      value: c,
    }));
    return categoriesSelectOptions;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("people")) {
      const people = parseInt(params.get("people") || info.experience.people);
      const date = moment(
        params.get("date") === undefined
          ? info.experience.date
          : params.get("date")
      );
      const category = params.get("category") || info.experience.category;
      const duration = params.get("duration") || info.experience.duration;
      info.setExperience({
        ...info.experience,
        people,
        date,
        category,
        duration,
      });
    }
  }, []);

  useEffect(() => {
    (async () => {
      let experiences = await searchExperiences(info, store);
      setProducts(experiences);
      if (!experiences?.length) return;
      // get available categories
      const categories = getAllUniqueValues("exp_category", experiences);
      const categoryOptions = createSelectOptions(categories);
      setCategories(categoryOptions);

      // get available types
      const durations = getAllUniqueValues("exp_duration", experiences);
      const durationOptions = createSelectOptions(
        durations,
        EXPERIENCES.durations
      );
      setDurations(durationOptions);
    })();
  }, [info.villages, info.name, info.experience, info.immediateConfirmation]);

  const handleChange = (type, value) => {
    info.setExperience({ ...info.experience, [type]: value });
  };

  return (
    <>
      <div className="ahp-service-filter">
        <div>
          <div style={{ display: "inline", marginTop: 6 }}>
            {info.t("people")}:
          </div>
          <AHPSelect
            label={info.t("people")}
            type="experience"
            field="people"
            options={EXPERIENCES.PEOPLE_OPTIONS}
            width={FIELD_WIDTHS.XS}
          />
        </div>

        <DatePicker
          disabledDate={(current) => current && current < moment()}
          style={{ width: FIELD_WIDTHS.M }}
          onChange={(value) => handleChange("date", value)}
          placeholder={info.t("date")}
          bordered={false}
          value={info.experience.date}
        />

        <AHPSelect
          label={info.t("type")}
          type="experience"
          field="category"
          options={categories}
          allowClear
        />

        <AHPSelect
          label={info.t("duration")}
          type="experience"
          field="duration"
          options={durations}
          allowClear
        />
      </div>
    </>
  );
};

export default StoreExperienceFilter;
